import { render, staticRenderFns } from "./account_complaint.vue?vue&type=template&id=2392ba26&scoped=true"
import script from "./account_complaint.vue?vue&type=script&lang=js"
export * from "./account_complaint.vue?vue&type=script&lang=js"
import style0 from "./account_complaint.vue?vue&type=style&index=0&id=2392ba26&prod&scoped=true&lang=css"
import style1 from "./account_complaint.vue?vue&type=style&index=1&id=2392ba26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392ba26",
  null
  
)

export default component.exports